<template>
  <div>
    <div class="row mt-20">
      <div class="container">
        <div class="col-md-12">
          <div id="delivery-bg" class="bg-pos"></div>
        </div>
      </div>
    </div>
    <div class="row mt-20">
      <div class="container">
        <div class="col-md-12">
          <div class="h2 bold text-center">
            {{ $t('deliveryPage.deliveryHeader') }}
          </div>
          <div v-html="$t('deliveryPage.first')"></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="container">
        <div class="col-md-12">
          <div class="h2 bold text-center">
            {{ $t('deliveryPage.changeHeader') }}
          </div>
          <div v-html="$t('deliveryPage.second')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Delivery',
}
</script>

<style></style>
